module.exports = __webpack_public_path__ + "img/icon-add.80c1322b.svg";